/* eslint-disable import/prefer-default-export */
export function getLoginFailureOptions(error) {
  const errorCode = error.response?.data.error?.code;
  const errorMessage = error.response?.data.error?.message ?? error.message;

  switch (errorCode) {
    case 'ERR_USER_NOT_FOUND':
    case 'ERR_INVALID_CREDENTIALS':
      return {
        title: 'Credenciais incorretas',
        message: 'Confira o usuário e senhas digitados e tente novamente.',
      };
    default:
      return { errorList: [errorMessage] };
  }
}
